import React from 'react';
import { TValidationResult } from '../types';

export interface IFormContext<
  ValueType extends Record<string, unknown> = Record<string, unknown>,
  SubmitValueType extends Record<keyof ValueType, unknown> = ValueType,
> {
  avoidFieldsTouch?: boolean;
  name: string;
  validate: () => Promise<TValidationResult<ValueType, SubmitValueType>>;
}

export const FormContext = React.createContext<IFormContext>(
  {} as IFormContext,
);

/**
 * Provee acceso de forma sencilla al contexto de
 * validación, que básicamente posee el nombre del
 * form en caso de que se quiera usar para acceder
 * a través de Redux a la información del mismo y un
 * método validate, que dispara la validación del
 * form.
 *
 * En la práctica, el método validate es casi
 * innecesario, ya que la validación se puede disparar
 * con cualquier botón que no tenga seteado el
 * atributo type="button" (esto es así ya que en el
 * DOM se renderiza un elemento de tipo form).
 */
export function useFormContext() {
  const formContext = React.useContext(FormContext);
  if (!formContext) throw new Error('There is no FormContext');
  return formContext;
}
